import React, { useEffect, useState } from 'react';
import { Row, Container } from 'reactstrap';

import Details from './Details';
import DetailsV2 from './DetailsV2';
import Additional from './Additional';
import FileUpload from './FileUpload';

import { initialEntryFormData } from '../../utils/InitialData';
import Trophy from './Trophy';
import Terms from './Terms';

import axios from "axios";
import CustomToast from '../../utils/CustomToast';
import useSiteCookies from './useSiteCookies';
import { useHistory, useLocation } from 'react-router-dom';

const EntryFormV2 = (props) => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    let query = useQuery();
    const entry_id = query.get('entry_id');
    const page = query.get('page');

    const {currentUser, token, userRole} = useSiteCookies();

    const [stepPage, setStepPage] = useState(1);
    const [formData, setFormData] = useState(initialEntryFormData);

    const [categoryQuestionsOne, setCategoryQuestionsOne] = useState([]);
    const [categoryQuestionsTwo, setCategoryQuestionsTwo] = useState([]);
    const [categoryQuestionsThree, setCategoryQuestionsThree] = useState([]);
    const [categoryQuestionLoading, setCategoryQuestionsLoading] = useState(true);

    const [category, setCategory] = useState([]);
    const [categoryLoading, setCategoryLoading] = useState(true);

    const [formStatus, setFormStatus] = useState(false);
    const [submitFormStatus, setSubmitFormStatus] = useState(false);

    const location = useLocation();
    var currentPathName = location.pathname;

    // const paidAwards = [47, 7, 67, 125];
    const paidAwards = [47, 7, 67, 125, 166];

    const getCategory = async () => {
        return await axios.get(
            process.env.REACT_APP_API_ENDPOINT + `category/${props.categoryId}`,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const postEntry = async (data) => {
        return await axios.post(
            process.env.REACT_APP_API_ENDPOINT + `entry-v2`, data,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const putEntry = async (id, data) => {
        return await axios.put(
            process.env.REACT_APP_API_ENDPOINT + `entry-v2/${id}`, data,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const toggleSubmitDraft = (e) => {
        const updatedPayload = {
            ...formData,
            ...e,
            status: 'Draft',
            user_id: props.userId,
            category_id: props.categoryId,

            additional_content: { 
                ...(formData.additional_content || {}), 
                ...(e.additional_content || {}) 
            }
        }

        setFormStatus(true);
        
        if (entry_id) {
            putEntry(entry_id, updatedPayload).then(response => {
                const status = response.data.status;
                if (status === 'Success') {
                    CustomToast.success("Saved as draft!")
                    // setFormStatus(false);
                    if (userRole && userRole === 'Admin') {
                        window.location.href='/admin/entry?entry_id=' + entry_id
                    } else {
                        window.location.href='/entrant/categories';
                    }
                } else {
                    CustomToast.defaultWarning();
                    setFormStatus(false);
                }
            }).catch(() => {
                CustomToast.defaultError();
                setFormStatus(false);
            });
        } else {
            postEntry(updatedPayload).then(response => {
                const status = response.data.status;
                if (status === 'Success') {
                    const data = response.data.data;
                    
                    CustomToast.success("Saved as draft!")
                    // setFormStatus(false);

                    // if (data && userRole === 'Entrant') {
                    //      window.location.href=`/entrant/category/entry-form?category_id=${props.categoryId}&entry_id=${data.id}`
                    // }
                    window.location.href='/entrant/categories';
                } else {
                    CustomToast.defaultWarning();
                    setFormStatus(false);
                }
            }).catch(() => {
                CustomToast.defaultError();
                setFormStatus(false);
            });
        }
    }

    const toggleSubmit = (e) => {
        const updatedPayload = {
            ...formData,
            ...e,
            status: 'Pending',
            user_id: props.userId,
            category_id: props.categoryId
        }
        submitForm(updatedPayload);
    }

    const toggleSubmitTrophy = (e) => {
        const updatedPayload = {
            ...formData,
            ...e,
            status: 'Pending',
            user_id: props.userId,
            category_id: props.categoryId
        }
        submitForm(updatedPayload);
    }

    const submitForm = (updatedPayload) => {
        setSubmitFormStatus(true);
        if (entry_id) {
            putEntry(entry_id, updatedPayload).then(response => {
                const status = response.data.status;
                const result = response.data.data;
                if (status === 'Success') {
                    CustomToast.success("Entry has been submitted successfully!")
                    // setFormStatus(false);
                    if (userRole && userRole == 'Admin') {
                        window.location.href='/admin/entry?entry_id=' + entry_id
                    } else {
                        if (paidAwards.includes(Number(props.awardData.id)) && updatedPayload.free == false && formData.paid == 0) {
                            window.location.href = `/entry/stripe?code=${result.entry.code}&award_code=${props.awardData.award_type.code.replace('&', '%26')}${result.entry.first_name === 'Jeno (Test)' ? '&test=1' : result.entry.first_name === 'BR 1Eur Test' ? '&oneeuro=1' : ''}`
                        } else {
                            window.location.href = '/entrant/category?category_id=' + props.categoryId + '&show=1&entry_id=' + entry_id;
                        }
                    }
                } else {
                    CustomToast.defaultWarning();
                    setFormStatus(false);
                }
            }).catch(() => {
                CustomToast.defaultError();
                setFormStatus(false);
            });
        } else {
            postEntry(updatedPayload).then(response => {
                const status = response.data.status;
                const result = response.data.data;
                if (status === 'Success') {
                    CustomToast.success("Entry has been submitted successfully!")
                    // setFormStatus(false);

                    if (paidAwards.includes(Number(props.awardData.id)) && updatedPayload.free == false && formData.paid == 0) {
                        window.location.href =  `/entry/stripe?code=${result.entry.code}&award_code=${props.awardData.award_type.code.replace('&', '%26')}${result.entry.first_name.toLowerCase() === 'jeno (test)' || result.entry.first_name.toLowerCase() === 'jeno(test)' ? '&test=1' : result.entry.first_name === 'BR 1Eur Test' ? '&oneeuro=1' : ''}`
                    } else {
                        window.location.href = '/entrant/category?category_id=' + props.categoryId + '&show=1&entry_id=' + response.data.data.id;
                    }
                } else {
                    CustomToast.defaultWarning();
                    setFormStatus(false);
                }
            }).catch(() => {
                CustomToast.defaultError();
                setFormStatus(false);
            });
        }
    }

    useEffect(() => {
        if (props.categoryQuestions) {
            const categoryQuestions = props.categoryQuestions;

            const categoryQuestionsNumberOne = categoryQuestions.filter(item => Number(item.position) === 1);
            const categoryQuestionsNumberTwo = categoryQuestions.filter(item => Number(item.position) === 2);
            const categoryQuestionsNumberThree = categoryQuestions.filter(item => Number(item.position) === 3);

            setCategoryQuestionsOne(categoryQuestionsNumberOne);
            setCategoryQuestionsTwo(categoryQuestionsNumberTwo);
            setCategoryQuestionsThree(categoryQuestionsNumberThree);

            setCategoryQuestionsLoading(false);
        } else {
            CustomToast.defaultError();
            setCategoryQuestionsLoading(false);
        }

        if (props.userType && props.userType === 'Entrant') {
            setFormData(prev => ({
                ...prev,
                user_id: currentUser,
            }));
        }

        if (props.categoryId && props.categoryId !== '') {
            setFormData(prev => ({
                ...prev,
                category_id: props.categoryId,
            }));
        }

        if (props.country && props.country === 'Ireland') {
            setFormData(prev => ({
                ...prev,
                organization_country: props.country,
            }));
        }

        if (props.formData) {
            setFormData(props.formData);
        }
    }, []);

    useEffect(() => {
        getCategory().then(response => {
            const data = response.data.data;
            if (data) {
                setCategory(data);
                setCategoryLoading(false);
            } else {
                CustomToast.defaultWarning();
                setCategoryLoading(false);
            }
        }).catch(() => {
            CustomToast.defaultError();
            setCategoryLoading(false);
        });
    }, []);

    const nextPage = () => {
        setStepPage(prevStep => {
            const newStep = prevStep + 1;
            props.onStep(newStep);
            return newStep;
        });

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    const prevPage = () => {
        setStepPage(prevStep => {
            const newStep = prevStep - 1;
            props.onStep(newStep);
            return newStep;
        });

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    useEffect(() => {
        if (page && currentPathName == "/entry-form/preview") {
            setStepPage(Number(page));
        }
    }, [page])

    useEffect(() => {
        if (page && currentPathName == "/entry-form/preview") {
            const location = window.location;
            const updatedQuery = new URLSearchParams(location.search);
            updatedQuery.set("page", stepPage);

            const newUrl = `${location.pathname}?${updatedQuery.toString()}`;
            window.history.replaceState(null, "", newUrl);
        }
    }, [stepPage])

    return (
        <>
            <Container>
                <Row>
                    {stepPage === 1 ?
                        <>
                            {props.awardData.id != 118 && props.awardData.id != 125 ?
                                // <Details
                                //     country={props.country}
                                //     awardData={props.awardData}

                                //     onNextPage={nextPage}
                                //     onDraftSubmit={toggleSubmitDraft}

                                //     onData={(e) => setFormData({ 
                                //         ...formData, 
                                //         ...e.details, 
                                //         additional_content: { 
                                //             ...(formData.additional_content || {}), 
                                //             ...(e.details.additional_content || {}) 
                                //         }
                                //     })}
                                    
                                //     data={formData}

                                //     draftStatus={formStatus}
                                //     categoryQuestions={categoryQuestionsOne}

                                //     entry_id={entry_id}
                                //     category_id={props.categoryId}
                                // />                                
                                <DetailsV2
                                    country={props.country}
                                    awardData={props.awardData}

                                    onNextPage={nextPage}
                                    onDraftSubmit={toggleSubmitDraft}

                                    onData={(e) => setFormData({ 
                                        ...formData, 
                                        ...e.details,
                                    })}
                                    
                                    data={formData}

                                    draftStatus={formStatus}
                                    categoryQuestions={categoryQuestionsOne}

                                    entry_id={entry_id}
                                    category_id={props.categoryId}
                                    category={category}
                                />
                            :
                                <Details
                                    country={props.country}
                                    awardData={props.awardData}

                                    onNextPage={nextPage}
                                    onDraftSubmit={toggleSubmitDraft}

                                    onData={(e) => setFormData({ 
                                        ...formData, 
                                        ...e.details, 
                                        additional_content: { 
                                            ...(formData.additional_content || {}), 
                                            ...(e.details.additional_content || {}) 
                                        }
                                    })}
                                    
                                    data={formData}

                                    draftStatus={formStatus}
                                    categoryQuestions={categoryQuestionsOne}

                                    entry_id={entry_id}
                                    category_id={props.categoryId}
                                    category={category}
                                />
                            }
                        </>
                    : null}
                    {(stepPage === 2 && categoryQuestionsTwo.length > 0) &&
                        <Additional
                            onPrevPage={prevPage}
                            onNextPage={nextPage}
                            onDraftSubmit={toggleSubmitDraft}

                            onData={(e) => setFormData({ ...formData, category_question_answers_2: e.additional })}
                            data={formData}

                            categoryQuestions={categoryQuestionsTwo}
                            questionLoading={categoryQuestionLoading}

                            draftStatus={formStatus}
                        />
                    }
                    {(stepPage === 3 && categoryQuestionsTwo.length > 0) || (stepPage === 2 && categoryQuestionsTwo.length < 1) ? (
                        <FileUpload
                            onPrevPage={prevPage}
                            onNextPage={nextPage}
                            onDraftSubmit={toggleSubmitDraft}

                            onData={(e) => setFormData({ 
                                ...formData, 
                                ...e.files, 
                                additional_content: { 
                                    ...(formData.additional_content || {}), 
                                    ...(e.files.additional_content || {}) 
                                }
                            })}

                            data={formData}

                            category={category}
                            categoryQuestions={categoryQuestionsThree}
                            categoryLoading={categoryLoading}

                            draftStatus={formStatus}
                        />
                    ) : null}
                    {(stepPage === 4 && categoryQuestionsTwo.length > 0) || (stepPage === 3 && categoryQuestionsTwo.length < 1) ? (
                        <Trophy
                            onPrevPage={prevPage}
                            onNextPage={nextPage}
                            onDraftSubmit={toggleSubmitDraft}

                            onData={(e) => setFormData({ ...formData, ...e.trophy_data })}
                            data={formData}

                            draftStatus={formStatus}
                            userRole={userRole}
                            submitFormStatus={submitFormStatus}

                            onSubmit={(e) => toggleSubmitTrophy(e)}
                        />
                    ) : null}
                    {(stepPage === 5 && categoryQuestionsTwo.length > 0) || (stepPage === 4 && categoryQuestionsTwo.length < 1) ? (
                        <Terms
                            onPrevPage={prevPage}
                            onDraftSubmit={toggleSubmitDraft}
                            onSubmit={(e) => toggleSubmit(e)}

                            onData={(e) => setFormData({ ...formData, ...e.terms })}
                            data={formData}

                            award={props.awardData}

                            draftStatus={formStatus}
                            submitFormStatus={submitFormStatus}
                            current_user_id={currentUser}
                            current_user_token={token}
                        />
                    ) : null}
                </Row>
            </Container>
        </>
    );
};

export default EntryFormV2;